import React from "react";
import { Box, Typography } from "@mui/material";
import { FONT_SIZE } from "../../constants/fontSizes";

/**
 * セクション／ページ共通タイトル
 * variant:
 * - "page"    : ページタイトル（大きめ）
 * - "section" : セクションタイトル（通常）
 */
const SectionTitle = ({ title, variant = "section" }) => {
  const isPage = variant === "page";

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* 左アクセントバー（page のときは非表示） */}
      {!isPage && (
        <Box
          sx={{
            width: 4,
            height: 18,
            backgroundColor: "#4951D0",
            borderRadius: 2,
            mr: 1,
          }}
        />
      )}

      {/* タイトル文字 */}
      <Typography
        sx={{
          fontSize: isPage ? FONT_SIZE.XL : FONT_SIZE.LG,
          fontWeight: "bold",
          color: "#4951D0",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default SectionTitle;
